import * as ProductAnalyticsReducer from './ProductAnalyticsReducers';
import * as ProductAnalyticsActions from './ProductAnalyticsActions';

export {
    ProductAnalyticsReducer,
    ProductAnalyticsActions,
}


// WEBPACK FOOTER //
// ./src/modules/productAnalytics/index.js